import { parseResponse } from 'hono/client';
import { getIdApi } from '@/common/api/id/getIdApi';

export const getPendingInvites = async () => {
  const api = getIdApi();
  const response = await api.profile.v1['pending-invites'].$get();
  return parseResponse(response);
};

export const acceptUserInvite = async (params: { inviteId: number }) => {
  const api = getIdApi();
  const response = await api.profile.v1.invites[':inviteId'].accept.$put({
    param: { inviteId: String(params.inviteId) },
  });
  return parseResponse(response);
};

export const getInviteEntryInfo = async (inviteId: number) => {
  const api = getIdApi();
  const response = await api.profile.v1.invites[':inviteId'].entry.$get({
    param: { inviteId: String(inviteId) },
  });
  return parseResponse(response);
};
